import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { IconTooltip, IconTooltipProps } from './IconTooltip';

interface AdditionalProps {
  isVisible?: boolean;
}

export const WarningTooltip: React.FC<
  PropsWithChildren<Omit<IconTooltipProps, 'color' | 'icon'>> & AdditionalProps
> = ({ children, title, placement = 'top-end', isVisible = true }) => {
  if (!isVisible) {
    return <>{children}</>;
  }
  return (
    <Box display="flex">
      <Box flex="auto">{children}</Box>
      <IconTooltip
        icon="triangle-exclamation"
        color="warning"
        title={title}
        placement={placement}
      />
    </Box>
  );
};
